<template>
  <section class="filestore-wrapper">
    <router-view></router-view>
  </section>
</template>
<script>
import { EventBus } from '@/eventbus/EventBus'
import ErrorMessage from '@/dialogs/ErrorMessage.vue'
import ArchiveUsersMixin from '@/features/filestore/ArchiveUsersMixin'
import { getUser } from '@/api/api.js'
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'

export default {
  mixins: [ArchiveUsersMixin],
  computed: {
    ...mapStores(useFileStoreStore)
  },
  async created() {
    EventBus.on('fileStoreErrorDialog', this.onFileStoreErrorDialog)
    EventBus.on('archiveCreated', this.onArchiveCreated)

    await getUser()

    this.$router.push({ name: 'fileStoreDashboard' })
  },
  unmounted() {
    EventBus.off('archiveCreated', this.onArchiveCreated)
    EventBus.off('fileStoreErrorDialog', this.onFileStoreErrorDialog)
  },
  methods: {
    onArchiveCreated({ archiveId, folderId }) {
      this.$router.push({
        name: 'fileStoreFolder',
        params: { archiveId: archiveId, folderId: folderId }
      })

      this.$modal.show('dialog', {
        text: 'Uw nieuwe archief is klaar voor gebruik.',
        buttons: [
          {
            title: 'Sluiten',
            class: 'pill-button secondary',
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title: 'Gebruikers toevoegen',
            class: 'pill-button',
            handler: () => {
              this.$modal.hide('dialog')
              this.getUsers(archiveId)
            }
          }
        ]
      })
    },
    onFileStoreErrorDialog({ title, message }) {
      this.$modal.show(
        ErrorMessage,
        {
          title: title,
          text: message
        },
        {
          height: 'auto',
          width: 380,
          adaptive: true
        }
      )
    }
  }
}
</script>
<style lang="scss"></style>
